import React, { Component } from 'react';
import styled from 'styled-components';
var { FaPlay, FaFloppyO, FaCodeFork, FaShareAlt,
      // FaGlobe, FaHeart,
      FaAngleLeft, FaAngleRight, FaCode, FaTrash } = require('react-icons/lib/fa');
var { MdSettings } = require('react-icons/lib/md'); // MdWebAsset for screen
import Tooltip from './_Tooltip';
// import Modal from './_Modal';
import SaveForkModal from './_SaveForkModal';
import ShareModal from './_ShareModal';
import EmbedModal from './_EmbedModal';
// import PublicPrivateModal from './_PublicPrivateModal';
import SettingsModal from './_SettingsModal';
import DeleteModal from './_DeleteModal';
// import LoadingModal from './_LoadingModal';

// MODALS:
// Save:          timeout modal with checkbox
// Fork:          timeout modal with checkbox
// Share:         modal with social options, also with embed functionality
// Private:       slider with 'set to private' option --> deactivated because feature is not here yet
// Heart:         modal that indicates that liking also comes later.
// Settings:      Set things like tags, categories, description, sources etc
// Title:         To Settings

const Ul = styled.ul`
  box-sizing: border-box;
  list-style-type: none;
  margin: 0;
  padding-left: 10px;
`
const Li = styled.li`
  float: left;
  padding: 5px 10px 5px 10px;
  transform: scale(1.2);
  &:hover {
    color: #fb4d47;
    cursor: pointer;
  }
  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 100;
  }
  position: relative;
  display: inline-block;
`
const LiRight = Li.extend`
  float: right;
`
// const Ro = styled.div`
//   transform-origin: 50% 55%;
//   transform: rotate(90deg);
// `

class Options extends Component {
  constructor() {
    super()
    this.state = {
      activeModal: "",
      justSaved: false,
      justForked: false,
    }
  }
  closeModal = (str) => {
    if (this.state.activeModal === str) {
      this.setState({ activeModal: "" });
    }
  }
  render() {
    const { ownershipStatus } = this.props;
    return (
      <Ul>

        <SaveForkModal
          open={this.state.activeModal === "save"}
          closeModal={this.closeModal}
          method="save"
        />
        <SaveForkModal
          open={this.state.activeModal === "fork"}
          closeModal={this.closeModal}
          method="fork"
        />
        <ShareModal
          evKey={this.props.evKey}
          open={this.state.activeModal === "share"}
          closeModal={this.closeModal}
          method="share"
        />
        <EmbedModal
          open={this.state.activeModal === "embed"}
          closeModal={this.closeModal}
          method="embed"
        />
        {/* <PublicPrivateModal
          open={this.state.activeModal === "public"}
          closeModal={this.closeModal}
          method="public"
        /> */}
        <DeleteModal
          open={this.state.activeModal === "delete"}
          deleteEnvelope={this.props.deleteEnvelope}
          closeModal={this.closeModal}
          method="delete"
        />
        <SettingsModal
          saveEnvelope={this.props.saveEnvelope}
          changeName={this.props.changeName}
          changeDescription={this.props.changeDescription}
          changeTags={this.props.changeTags}
          envelope={this.props.envelope}
          open={this.state.activeModal === "settings"}
          closeModal={this.closeModal}
          method="settings"
        />

        {/*

        STATUS VS OPTIONS:

                    RUN  SAVE  FORK  SHARE  EMBED  DELETE  SETTINGS
        NEW          V    V     X      X      X      X        V
        SIGNEDOUT    V    X     X      V      V      X        X
        OTHERS       V    X     V      V      V      X        X
        MINE         V    V     V      V      V      V        V

        */}

        <Li onClick={() => this.props.run()}             ><FaPlay     /><Tooltip>(Re-)Run</Tooltip></Li>

        {ownershipStatus === "new" || ownershipStatus === "mine" ?
          <Li onClick={this.props.saveEnvelope}    ><FaFloppyO  /><Tooltip>Save</Tooltip></Li> :
          null}
        {ownershipStatus === "new" ? null :
          <Li onClick={this.props.forkEnvelope}    ><FaCodeFork /><Tooltip>Copy</Tooltip></Li>}
        {ownershipStatus === "new" ? null :
          <Li onClick={() => this.setState({ activeModal: "share" })}   ><FaShareAlt /><Tooltip>Share</Tooltip></Li>}
        {ownershipStatus === "new" ? null :
          <Li onClick={() => this.setState({ activeModal: "embed" })}   ><FaCode     /><Tooltip>Embed</Tooltip></Li>}
        {ownershipStatus === "mine" ?
          <Li onClick={() => this.setState({ activeModal: "delete" })} ><FaTrash /> <Tooltip>Delete</Tooltip></Li> :
          null}
        {ownershipStatus === "new" || ownershipStatus === "mine" ?
          <Li onClick={() => this.setState({ activeModal: "settings" })}><MdSettings /><Tooltip>Settings</Tooltip></Li> :
          null}
        {this.props.collapsed ? (
          <Li onClick={this.props.collapse}><FaAngleRight />    <Tooltip>Expand</Tooltip></Li>
        ) : (
          <LiRight onClick={this.props.collapse}><FaAngleLeft /><Tooltip>Collapse</Tooltip></LiRight>
        )}
      </Ul>
      // {/* <Li onClick={() => this.setState({ activeModal: "public" })}  ><FaGlobe    /><Tooltip>Public / Private</Tooltip></Li> */}
      // {/* <Li><FaHeart />                     <Tooltip>Heart</Tooltip></Li> */}
    )
  }
}

export default Options



// WEBPACK FOOTER //
// ./src/_Options.js